import React from 'react';
import { useTranslation } from 'react-i18next';

const AccountSupport = () => {
  const { t } = useTranslation();

  return (
    <div className={'col-12 col-md-6 px-3 py-4'} style={{ minHeight: '100%' }}>
      <div className="termsAndPrivacy">
        <h4>{t('I am unable to login to my account. My username and password are correct')}</h4>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt est eu egestas dapibus. Interdum et malesuada fames ac ante ipsum primis in faucibus. Sed molestie efficitur augue, vel tincidunt.</p>
        <br/>
        <h4>{t('Report an account')}</h4>
        <p>of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.</p>
        <br/>
        <h4>{t('Deleting your account')}</h4>
        <p>Sed blandit sem orci, vel tempor elit rhoncus quis. Aenean eget feugiat dui. Praesent quis turpis tincidunt, pharetra mi ut, imperdiet leo. Ut bibendum</p>
      </div>
    </div>
  );
};

export default AccountSupport;